import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerComponent } from './../common/components/drawer/drawer.component';
import { HeaderComponent } from './../common/components/header/header.component';
import { FooterComponent } from './../common/components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusNextPrevDirective } from 'src/app/common/directives/focus-next-prev-element.directive';
import { SidebarComponent } from './../common/components/sidebar/sidebar.component';
import { TimerComponent } from './../common/components/timer/timer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
@NgModule({
  declarations: [
    DrawerComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    TimerComponent,
    FocusNextPrevDirective,
    ToggleSwitchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ],
  exports: [
    DrawerComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    NgxSpinnerModule,
    TimerComponent,
    FocusNextPrevDirective,
    FormsModule,
    ReactiveFormsModule,
    ToggleSwitchComponent
  ]
})
export class SharedModule { }
